import React from 'react'
import { TextPropertiesProps } from './types'
import {
  PropertySection,
  SectionHeader,
  SectionTitle,
  CollapseIcon,
  SectionContent,
  PropertyGroup,
  Label,
  Input,
  TextArea,
  Select,
  Checkbox,
  FlexRow,
  RangeInput,
  RangeValue,
} from '../styled'

const TextProperties: React.FC<TextPropertiesProps> = ({
  selectedElement,
  localProperties,
  isCollapsed,
  onToggleSection,
  updateProperty,
}) => {
  return (
    <PropertySection>
      <SectionHeader isCollapsed={isCollapsed} onClick={onToggleSection}>
        <SectionTitle>Text Properties</SectionTitle>
        <CollapseIcon isCollapsed={isCollapsed}>▼</CollapseIcon>
      </SectionHeader>
      <SectionContent isCollapsed={isCollapsed}>
        <PropertyGroup>
          <Label>Text Content</Label>
          <TextArea
            value={localProperties.text || ''}
            onChange={e => updateProperty('text', e.target.value)}
            placeholder="Enter text content"
          />
        </PropertyGroup>
        <PropertyGroup>
          <Label>Font Size</Label>
          <FlexRow>
            <RangeInput
              min="8"
              max="72"
              value={localProperties.fontSize || 16}
              onChange={e => updateProperty('fontSize', Number(e.target.value))}
            />
            <RangeValue>{localProperties.fontSize || 16}px</RangeValue>
          </FlexRow>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Font Family</Label>
          <Select
            value={localProperties.fontFamily || 'Arial'}
            onChange={e => updateProperty('fontFamily', e.target.value)}>
            <option value="Arial">Arial</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Georgia">Georgia</option>
            <option value="Verdana">Verdana</option>
            <option value="Helvetica">Helvetica</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>
            <Checkbox
              checked={localProperties.bold || false}
              onChange={e => updateProperty('bold', e.target.checked)}
            />
            Bold
          </Label>
        </PropertyGroup>
        <PropertyGroup>
          <Label>
            <Checkbox
              checked={localProperties.italic || false}
              onChange={e => updateProperty('italic', e.target.checked)}
            />
            Italic
          </Label>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Text Rotation (degrees)</Label>
          <FlexRow>
            <RangeInput
              min="-180"
              max="180"
              value={localProperties.rotation ?? 0}
              onChange={e => updateProperty('rotation', Number(e.target.value))}
            />
            <Input
              type="number"
              min="-180"
              max="180"
              value={localProperties.rotation ?? 0}
              onChange={e => updateProperty('rotation', Number(e.target.value))}
              style={{ width: '80px', marginLeft: '8px' }}
            />
            <RangeValue>{localProperties.rotation ?? 0}°</RangeValue>
          </FlexRow>
        </PropertyGroup>
      </SectionContent>
    </PropertySection>
  )
}

export { TextProperties }
